import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './SplashScreen.css';

interface SplashScreenProps {
  onDone: () => void;
  /** Auto-dismiss after this many ms (default 2800) */
  duration?: number;
}

export default function SplashScreen({ onDone, duration = 2800 }: SplashScreenProps) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), duration);
    return () => clearTimeout(timer);
  }, [duration]);

  const handleExit = () => {
    onDone();
  };

  return (
    <AnimatePresence onExitComplete={handleExit}>
      {visible && (
        <motion.div
          className="splash"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: 'easeInOut' }}
          onClick={() => setVisible(false)}
        >
          {/* ── Gradient blobs ── */}
          <div className="splash__gradient-container">
            <div className="splash__blob splash__blob--1" />
            <div className="splash__blob splash__blob--2" />
            <div className="splash__blob splash__blob--3" />
            <div className="splash__blob splash__blob--4" />
            <div className="splash__blob splash__blob--5" />
          </div>

          {/* ── Noise overlay ── */}
          <div className="splash__noise" />

          {/* ── Logo ── */}
          <div className="splash__center">
            <motion.div
              className="splash__icon"
              initial={{ scale: 0, opacity: 0, rotate: -12 }}
              animate={{ scale: 1, opacity: 1, rotate: 0 }}
              transition={{
                type: 'spring',
                stiffness: 260,
                damping: 18,
                delay: 0.3,
              }}
            >
              <motion.img
                className="splash__logo"
                src="/stories-bg-1.svg"
                alt="HU"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.55, duration: 0.4 }}
              />
            </motion.div>

            <motion.div
              className="splash__text-logo-wrap"
              initial={{ y: 16, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.85, duration: 0.5, ease: 'easeOut' }}
            >
              <img
                className="splash__text-logo"
                src="/heads-up-text.svg"
                alt="HEADS UP POKER CLUB"
              />
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
